import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { firstValueFrom, switchMap } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserInfoReponse } from '../models/claim.model';
import { Dealer } from '../models/dealer.model';
import { AuthService } from '../services/auth.service';
import { DealerService } from '../services/dealer.service';
import { SetDealersAction } from '../states/dealer/dealer.actions';
import { SetUserInfo } from '../states/user/user.actions';
import { DealerStateSelectors } from '../states/dealer/dealer-state.selectors';

@Injectable()
export class AppInitService {
  initializeApp(authService: AuthService, dealerService: DealerService, store: Store): Promise<Dealer> {
    return firstValueFrom(
      authService.getUserInfo().pipe(
        switchMap((result: UserInfoReponse) => {
          if (!result?.isAuthenticated) {
            return Promise.resolve(null);
          }
          store.dispatch(new SetUserInfo(result));

          const userId = result.userClaims.find(x => x.key === 'sub')?.value;
          const dealerId = window.location.search.split('dealerId=')[1];

          return firstValueFrom(
            dealerService.getDealersByUserId(userId).pipe(
              switchMap((dealers: Dealer[]) => {
                if (!dealers || dealers.length === 0) {
                  return Promise.resolve(null);
                }

                store.dispatch(new SetDealersAction(dealers, dealerId));

                return store.select(DealerStateSelectors.activeDealer).pipe(filter(dealer => dealer !== null));
              })
            )
          );
        })
      )
    );
  }
}
